const images = {
  logo_white: require('Images/logo_white.png'),
  logo: require('Images/logo.png'),
  icon: require('Images/logo_white.png'),
  icons: require('Images/Icons').default
}

export default images
